var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScatterEsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V31H32",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.23877,
  cy: 24.6211,
  r: 2,
  fill: "#BC0300"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.23877,
  cy: 19,
  r: 2,
  fill: "#04BD24"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 23.5,
  r: 2,
  fill: "#FFBF0D"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.2388,
  cy: 18,
  r: 2,
  fill: "#FF8900"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.2388,
  cy: 18,
  r: 2,
  fill: "#FD4F03"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.2109,
  cy: 16.4844,
  r: 2,
  fill: "#04BD24"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.2388,
  cy: 13,
  r: 2,
  fill: "#FD4F03"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 22.5,
  r: 2,
  fill: "#9FD926"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 8.5,
  r: 2,
  fill: "#FFA032"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 8.5,
  r: 2,
  fill: "#9FD926"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.2388,
  cy: 4,
  r: 2,
  fill: "#04BD24"
})));
export { SvgScatterEsg as ReactComponent };
export default __webpack_public_path__ + "scatter_esg.f794fc66885db7ab33aae0c41a3a3cd8.svg";